<template>
  <div>
    <b-modal
        :title="$t('Meeting settings')"
        v-model="show"
        dialog-class="trans-modal bg-app"
        size="lg"
        :hide-footer="true"
        no-close-on-backdrop>
      <ValidationObserver ref="form" tag="form" @submit.prevent="save()" style="max-width: 550px; margin: 0 auto">
        <b-form-group class="mb-3">
          <div>{{$t("What kind of meeting room do you want?")}}</div>
          <b-radio-group v-model="formData.idMeetType">
            <b-form-radio value="1">{{$t("Instant meeting")}}</b-form-radio>
            <b-form-radio value="2">{{$t("Scheduled meeting")}}</b-form-radio>
            <b-form-radio value="3">{{$t("Recurring meeting")}}</b-form-radio>
          </b-radio-group>
        </b-form-group>
        <b-form-group class="mb-3">
          <div>{{$t("What kind of authentication do you want with your users?")}}</div>
          <b-radio-group v-model="formData.idAuthen">
            <b-form-radio value="1">{{$t("Free join")}}</b-form-radio>
            <b-form-radio value="2">{{$t("Free join with account")}}</b-form-radio>
            <b-form-radio value="3">{{$t("Registered join")}}</b-form-radio>
          </b-radio-group>
        </b-form-group>
        <b-form-group class="mb-1">
          <b-checkbox v-model="formData.turnOffParticipantVideos">{{$t('Turn off video of participants')}}</b-checkbox>
        </b-form-group>
        <b-form-group class="mb-4">
          <b-checkbox v-model="formData.turnOffDingDong">{{$t('Turn off ding dong sound')}}</b-checkbox>
        </b-form-group>
        <b-form-group class="mb-0">
          <b-button type="submit" pill size="lg" class="btn-block btn-trans-primary" :disabled="loading">
            {{
              $t("Save changes")
            }}
          </b-button>
        </b-form-group>
      </ValidationObserver>
    </b-modal>
    <PanelLoading :show="loading" message="Saving data"/>
  </div>
</template>

<script>
import meetingService from "../services/meeting_service";
import dialogHelper from "../helpers/dialog_helper";

export default {
  name: "MeetingSettingsModal",
  data: function () {
    return {
      show: false,
      loading: false,
      formData: {
        idAuthen: 1,
        idMeetType: 1,
        turnOffParticipantVideos: false,
        turnOffHostVideo: false,
        turnOffDingDong: false
      }
    }
  },
  methods: {
    async open() {
      this.loading = true;
      let response = await meetingService.meetingSettings();
      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      let arr = response.substr(3).split('|');
      this.formData = {
        idAuthen: parseInt(arr[1]),
        idMeetType: parseInt(arr[0]),
        turnOffParticipantVideos: arr[2] != 1,
        turnOffHostVideo: false,
        turnOffDingDong:  arr[4] != 1
      }

      this.show = true;
    },
    async save() {
      if ((await this.$refs.form.validate()) != true)
        return;

      const result = await dialogHelper.confirm("Are you sure to change meeting settings?");
      if (!result)
        return;

      if (this.loading == true)
        return;

      this.loading = true;
      const response = await meetingService.saveMeetingSettings( {
        idAuthen: this.formData.idAuthen,
        idMeetType: this.formData.idMeetType,
        turnOnParticipantVideos: !this.formData.turnOffParticipantVideos,
        turnOnHostVideo: !this.formData.turnOffHostVideo,
        turnOnDingDong: !this.formData.turnOffDingDong
      });

      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      dialogHelper.alert(response.substr(3), "success");
    }
  }
}
</script>

<style scoped>

</style>